/* Shared, reversible presentation repairs; never changes catalog or cart data. */
(() => {
  'use strict';
  const init = () => {
    const mq = matchMedia('(max-width:749px)');
    document.querySelectorAll('.amc-dept').forEach(root => {
      if (root.dataset.amcCategoryQuality) return;
      const more = root.querySelector('[data-amc-more-categories]');
      const destination = more?.querySelector('[data-amc-extra-categories]');
      if (!more || !destination) return;
      root.dataset.amcCategoryQuality = 'true';
      const groups = [...root.querySelectorAll(':scope > .amc-dept__tiles,:scope > .amc-dept__group:not(.amc-dept__group--other)')];
      const active = groups.find(g => g.querySelector('[aria-current="page"]')) || groups[0];
      const rows = groups.filter(g => g !== active).map(node => {const marker = document.createComment('category position'); node.before(marker); return {node, marker};});
      const adapt = () => {
        if (mq.matches) rows.forEach(({node}) => destination.append(node));
        else rows.forEach(({node, marker}) => marker.after(node));
        more.hidden = !mq.matches || rows.length === 0;
        if (!mq.matches) more.open = false;
        root.classList.toggle('amc-dept--mobile-ready', mq.matches);
      };
      adapt();
      mq.addEventListener('change', adapt);
      // Reveal the selected pill without moving the document or stealing focus.
      const current = active?.querySelector('[aria-current="page"]');
      const rail = current?.closest('.amc-dept__pills,.amc-dept__tiles');
      if (mq.matches && current && rail) rail.scrollLeft = Math.max(0, current.offsetLeft - rail.offsetLeft - 12);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', init);
  // Merchant badge must never sit over consent or a buying dialog.
  let bannerObserver;
  const syncConsent = () => {
    const banner = document.getElementById('shopify-pc__banner');
    const visible = !!banner && banner.getBoundingClientRect().height > 0 && getComputedStyle(banner).display !== 'none';
    document.body.classList.toggle('amc-consent-visible', visible);
    if (banner && !bannerObserver) {bannerObserver = new MutationObserver(syncConsent); bannerObserver.observe(banner, {attributes:true,attributeFilter:['style','hidden','aria-hidden']});}
  };
  syncConsent();
  new MutationObserver(records => {
    if(records.some(r => [...r.addedNodes,...r.removedNodes].some(n => n.nodeType === 1 && (n.id === 'shopify-pc__banner' || n.querySelector?.('#shopify-pc__banner'))))) {bannerObserver?.disconnect();bannerObserver=undefined;syncConsent();}
  }).observe(document.body,{childList:true});
})();

/* One header surface at a time: menu, search, account or cart. */
(() => {
  const header = document.querySelector('.amc-hdr');
  if (!header) return;
  const drawer = header.querySelector('.amc-hdr__drawer');
  const burger = header.querySelector('.amc-hdr__burger');
  const row = header.querySelector('.amc-hdr__searchrow');
  const search = header.querySelector('.amc-hdr__search-btn');
  const pop = header.querySelector('.amc-acct-pop');
  const acct = header.querySelector('.amc-hdr__acct');
  const cart = () => document.querySelector('cart-drawer');
  const isOpen = {
    menu: () => drawer && !drawer.hidden,
    search: () => row && !row.hidden,
    account: () => pop && !pop.hidden,
    cart: () => !!cart()?.classList.contains('active')
  };
  const close = {
    menu: () => { drawer.hidden = true; burger?.setAttribute('aria-expanded', 'false'); burger?.setAttribute('aria-label', 'Open menu'); },
    search: () => { row.hidden = true; search?.setAttribute('aria-expanded', 'false'); },
    account: () => { pop.hidden = true; acct?.setAttribute('aria-expanded', 'false'); },
    cart: () => cart()?.close?.()
  };
  const closeOthers = (keep) => Object.keys(close).forEach((k) => { if (k !== keep && isOpen[k]()) close[k](); });
  const watch = (el, key, attr) => el && new MutationObserver(() => { if (isOpen[key]()) closeOthers(key); }).observe(el, { attributes: true, attributeFilter: [attr] });
  watch(drawer, 'menu', 'hidden');
  watch(row, 'search', 'hidden');
  watch(pop, 'account', 'hidden');
  const watchCart = () => { const c = cart(); if (c && !c.dataset.amcWatched) { c.dataset.amcWatched = '1'; watch(c, 'cart', 'class'); } };
  watchCart();
  document.addEventListener('amc:cart-open', () => closeOthers('cart'));
  document.addEventListener('click', (e) => { if (e.target.closest('.amc-hdr__cart')) { watchCart(); closeOthers('cart'); } }, true);
  /* Escape closes every open header surface and returns focus to its control. */
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const open = Object.keys(isOpen).filter((k) => isOpen[k]());
    if (!open.length || (open.length === 1 && open[0] === 'account')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open.forEach((k) => close[k]());
    const focusTo = { menu: burger, search, cart: header.querySelector('.amc-hdr__cart') }[open.filter((k) => k !== 'account').pop()];
    focusTo?.focus({ preventScroll: true });
  }, true);
})();
